export default __webpack_public_path__ + "static/media/33t.8d1b51bd.jpg";